export const WHATSAPP_NUMBER = "32468063847";
export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
export const DEFAULT_WA_TEXT =
  "Hallo entertainmentshows.be! Ik wil graag meer info over een show of workshop.";
export const TAGLINE = "De beste shows, altijd dichtbij!";

export const IMG = {
  hero: "https://customer-assets-39nsmqrw.emergentagent.net/job_entertainment-shows/artifacts/e1be8d2ceede51c6_20250930_174848.jpg",
  goochelShow: "https://customer-assets-39nsmqrw.emergentagent.net/job_entertainment-shows/artifacts/7e71cb4799e99ea9__DSC2090.webp",
  goochelStage: "https://customer-assets-39nsmqrw.emergentagent.net/job_entertainment-shows/artifacts/7e71cb4799e99ea9__DSC2090.webp",
  tafelCards: "https://customer-assets-39nsmqrw.emergentagent.net/job_entertainment-shows/artifacts/90fee51efc95806f_IMG-20250907-WA0013.jpg",
  tafelHands: "https://customer-assets-39nsmqrw.emergentagent.net/job_entertainment-shows/artifacts/90fee51efc95806f_IMG-20250907-WA0013.jpg",
  circusAerial: "https://customer-assets-39nsmqrw.emergentagent.net/job_entertainment-shows/artifacts/e1be8d2ceede51c6_20250930_174848.jpg",
  circusFire: "https://customer-assets-39nsmqrw.emergentagent.net/job_entertainment-shows/artifacts/e1be8d2ceede51c6_20250930_174848.jpg",
  workshopJuggle: "https://customer-assets-39nsmqrw.emergentagent.net/job_entertainment-shows/artifacts/e7116bf011afe5c5_IMG-20241031-WA0000.jpg",
  workshopBalloons: "https://images.unsplash.com/photo-1530104091755-015d31dfa0b9?crop=entropy&cs=srgb&fm=jpg&q=85",
  zakelijkGala: "https://images.unsplash.com/photo-1700514077430-3659e38eb5e7?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const SERVICES = [
  {
    slug: "goochelshows",
    title: "Goochelshows",
    tag: "Podiumshow",
    tagline: "Van kinderfeestje tot huwelijksfeest — een show die iedereen ketent aan zijn stoel.",
    description:
      "Van verdwijnkunsten tot onmogelijke onthullingen: een goochelshow op maat van jouw feest. Of dat nu een zaal vol spijkerkinderen is of een huwelijksdiner met gasten van 8 tot 80 — iedereen wordt betoverd.",
    image: IMG.goochelShow,
    hero: IMG.goochelStage,
    duration: "20 – 45 min",
    audience: "50 – 1000+ toeschouwers",
    location: "Podium, zaal of tuin",
    categories: ["goochelen"],
    features: [
      "Show op maat: kinderfeest, huwelijk of familiefeest",
      "Veel interactie met de jarige, het bruidspaar en de gasten",
      "Van intieme huiskamer tot grote feestzaal",
      "Volledig in het Nederlands",
    ],
  },
  {
    slug: "tafelgoochelaar",
    title: "Tafelgoochelaar",
    tag: "Close-up magie",
    tagline: "Magie op handhoogte tussen je gasten — aan tafel of tijdens het huwelijksdiner.",
    description:
      "De intiemste vorm van goochelen: kleine mirakels op handafstand, terwijl je gasten een glas nemen of tussen de gangen door. Een ijsbreker die van elke ontvangst een happening maakt.",
    image: IMG.tafelCards,
    hero: IMG.tafelHands,
    duration: "2 – 3 uur (walkaround)",
    audience: "Per groepje, heel de avond",
    location: "Receptie, diner of drank",
    categories: ["goochelen"],
    features: [
      "Close-up magie op enkele centimeters afstand",
      "IJsbreker tijdens recepties, diners en trouwfeesten",
      "Bruggetjes tussen gasten die elkaar nog niet kennen",
      "Met kaarten, munten, ringen en alledaagse voorwerpen",
      "Ideaal voor 20 tot 300 gasten",
    ],
  },
  {
    slug: "circusartiest",
    title: "Circusartiest",
    tag: "Circuskunst",
    tagline: "Acts met jongleren, eenwieler en steltenlopen — voor het kwartiertje dat iedereen onthoudt.",
    description:
      "Van jongleeracts tot eenwieler-skills en steltenlopen tussen je gasten door: circulair spektakel dat van jouw huwelijk, communie of buurtfeest een legende maakt.",
    image: IMG.circusAerial,
    hero: IMG.circusFire,
    duration: "10 – 30 min per set",
    audience: "1 – 3 sets per event",
    location: "Binnen & buiten",
    categories: ["circus"],
    features: [
      "Jongleeracts voor elk feest",
      "Eenwieler-acts, van grappig tot indrukwekkend",
      "Steltenlopen tussen je gasten door",
      "Binnen en buiten mogelijk",
    ],
  },
  {
    slug: "circusworkshops",
    title: "Circusworkshops",
    tag: "Actief & interactief",
    tagline: "Zelf de ster van het feest: jongleren, ballonnen, flowersticks en hoelahoepen.",
    description:
      "Een workshop waarin iedereen meedoet, van peuters tot grootouders. Onder begeleiding van een echte circusartiest ontdekken gasten jongleren, ballonnen, flowersticks en hoelahoepen. Ideaal voor kinderfeestjes, communies en familiefeesten.",
    image: IMG.workshopJuggle,
    hero: IMG.workshopJuggle,
    duration: "Vanaf ½ uur",
    audience: "8 – 120 deelnemers",
    location: "Thuis, school of feestzaal",
    categories: ["circus", "workshops"],
    features: [
      "Jongleren, ballonnen, flowersticks en hoelahoepen",
      "Alles materiaal aanwezig en volledig verzekerd",
      "Afgestemd op leeftijd en groepsgrootte",
      "Vanaf een half uurtje, zo lang als jij wil",
    ],
  },
];

export const OCCASIONS = [
  "Kinderfeest",
  "Verjaardag",
  "Huwelijk",
  "Communie",
  "Jubileum",
  "Bedrijfsfeest",
  "Anders",
];

export const MARQUEE_ITEMS = [
  "Goochelshows",
  "Tafelgoochelaar",
  "Circusartiest",
  "Circusworkshops",
  "Kinderfeesten",
  "Huwelijken",
  "Communies",
  "Bedrijfsevents",
  "Hoera!",
];
